// extracted by mini-css-extract-plugin
var _1 = "oqpW0wVDci";
export { _1 as "root" }
